import { t } from '@ankr.com/common';

export function getRequestsChartTranslations() {
  return {
    date: (value: Date) => t('requests-chart.date', { value }),
    time: (value: Date) => t('requests-chart.time', { value }),
    callsCount: (value: number) => t('requests-chart.calls-count', { value }),
    title: t('statistics.requests-chart.title'),
  };
}
